import React, { useEffect } from 'react';
import { PeekFormControl } from './PeekFormControl.js';
import { PeekFormLabel } from './PeekFormLabel.js';
import { resolvePath } from './PeekInput.js';
import { PeekListItemText } from './PeekListItemText.js';
import { PeekMenuItem } from './PeekMenuItem.js';
import { PeekSelect } from './PeekSelect.js';
import { PeekTypography } from './PeekTypography.js';
import { PeekStack } from './PeekStack.js';
import { theme } from '../themes/theme.js';

const PeekInputSelect = ({ form, field, placeholder, label, items, centerText, showBorder, labelProps, inputProps, required, horizontalLabel = false, }) => {
    useEffect(() => {
        if ((items === null || items === void 0 ? void 0 : items.length) === 1) {
            field.onChange({
                target: { name: field.name, value: items[0].id },
            });
        }
    }, [items]);
    if ((items === null || items === void 0 ? void 0 : items.length) === 1) {
        return (React.createElement(PeekFormControl, { fullWidth: true },
            label && (React.createElement(PeekFormLabel, { sx: Object.assign(Object.assign({}, ((labelProps === null || labelProps === void 0 ? void 0 : labelProps.sx) ? labelProps.sx : {})), (horizontalLabel && { minWidth: "130px", alignSelf: "center" })) },
                React.createElement(PeekStack, { direction: "row", gap: 0.3 },
                    label,
                    required && React.createElement(PeekTypography, { color: "error" }, "*")))),
            React.createElement(PeekTypography, { variant: "body1", height: theme.spacing(2.5), lineHeight: theme.spacing(2.5), py: theme.spacing(0.6), px: theme.spacing(1.2), mt: theme.spacing(0.2), border: `solid thin ${theme.palette.grey[100]}`, borderRadius: theme.spacing(0.8), sx: Object.assign({}, (horizontalLabel && { width: "100%" })) }, items[0].name)));
    }
    const { name } = field;
    const fieldTouched = resolvePath(form === null || form === void 0 ? void 0 : form.touched, name);
    const fieldError = resolvePath(form === null || form === void 0 ? void 0 : form.errors, name);
    const error = fieldTouched && Boolean(fieldError);
    const errorText = fieldTouched && fieldError;
    return (React.createElement(PeekFormControl, { fullWidth: true, sx: { flexDirection: horizontalLabel ? "row" : "column" } },
        label && (React.createElement(PeekFormLabel, { sx: Object.assign(Object.assign({}, ((labelProps === null || labelProps === void 0 ? void 0 : labelProps.sx) ? labelProps.sx : {})), (horizontalLabel && { minWidth: "130px" })) },
            React.createElement(PeekStack, { direction: "row", gap: 0.3 },
                label,
                required && React.createElement(PeekTypography, { color: "error" }, "*")))),
        items && (React.createElement(PeekSelect, Object.assign({}, field, { disabled: inputProps === null || inputProps === void 0 ? void 0 : inputProps.disabled, inputProps: Object.assign({ "aria-label": label || placeholder }, inputProps), MenuProps: {
                disablePortal: true,
            }, showBorder: showBorder, centerText: centerText, sx: Object.assign({}, (horizontalLabel && { width: "100%" })), displayEmpty: true, renderValue: (selected) => {
                var _a;
                if (!selected) {
                    return (React.createElement(PeekTypography, { variant: "body1", color: "text.disabled" }, placeholder));
                }
                return React.createElement(React.Fragment, null, (_a = items.find(({ id }) => id === selected)) === null || _a === void 0 ? void 0 : _a.name);
            }, error: error }), items.map(({ id, name }) => {
            return (React.createElement(PeekMenuItem, { key: id, value: id, "aria-label": name, hoverBgColor: "info", selectedBgColor: "info" },
                React.createElement(PeekListItemText, { primaryTypographyProps: { fontWeight: id == field.value ? "fontWeightBold" : "fontWeightRegular" } }, name)));
        }))),
        !!errorText && (React.createElement(PeekTypography, { variant: "body1", color: "error", mt: 0.6, sx: Object.assign({}, (horizontalLabel && { position: "absolute", marginTop: "35px", marginLeft: "130px" })) }, errorText))));
};

export { PeekInputSelect, PeekInputSelect as default };
